import { useEffect, useMemo, useRef, useState } from "react";
import api from "../api/client";

/* ── CSS ─────────────────────────────────────────────────── */
const CSS = `
:root {
  --bg:#f0f4fc; --surface:#ffffff; --s2:#f4f8ff; --border:#c0d0eb; --b2:#d5e3f5;
  --accent:#0f766e; --text:#0d1a36; --text2:#2a4a78; --muted:#6080aa;
  --green:#059669; --red:#dc2626; --amber:#b45309;
}
.bn-tabs { display:flex; border-bottom:1px solid var(--b2); margin-bottom:24px; }
.bn-tab { padding:0 20px; height:40px; font-size:12px; font-weight:500; color:var(--muted); background:none; border:none;
  border-bottom:2px solid transparent; margin-bottom:-1px; cursor:pointer; }
.bn-tab.active { color:var(--accent); border-bottom-color:var(--accent); font-weight:600; }
.bn-card { background:var(--surface); border:1px solid var(--border); border-radius:10px; padding:22px; margin-bottom:16px; }
.bn-card-title { font-size:11px; font-weight:700; letter-spacing:.07em; text-transform:uppercase; color:var(--muted); margin-bottom:14px; }
.bn-step { font-size:15px; font-weight:700; color:var(--text); margin-bottom:4px; }
.bn-step-sub { font-size:12px; color:var(--muted); margin-bottom:16px; }
.bn-row { display:flex; gap:14px; flex-wrap:wrap; margin-bottom:14px; }
.bn-field { display:flex; flex-direction:column; gap:5px; flex:1; min-width:220px; }
.bn-label { font-size:12px; font-weight:600; color:var(--text2); }
.bn-help { font-size:11px; color:var(--muted); }
.bn-input { background:var(--s2); border:1px solid var(--b2); border-radius:7px; padding:9px 12px; font-size:13px;
  color:var(--text); outline:none; font-family:inherit; width:100%; }
.bn-input:focus { border-color:var(--accent); }
.bn-input.err { border-color:var(--red); }
textarea.bn-input { min-height:72px; resize:vertical; }
.bn-err { font-size:11px; color:var(--red); }
.bn-choices { display:flex; gap:8px; flex-wrap:wrap; }
.bn-choice { padding:8px 14px; border:1px solid var(--b2); border-radius:7px; background:var(--s2); font-size:13px;
  color:var(--text2); cursor:pointer; }
.bn-choice.on { border-color:var(--accent); background:rgba(15,118,110,.08); color:var(--accent); font-weight:600; }
.bn-choice:disabled { opacity:.45; cursor:not-allowed; }
.bn-swatch { display:inline-block; width:12px; height:12px; border-radius:3px; border:1px solid rgba(0,0,0,.15); vertical-align:middle; margin-right:6px; }
.bn-btn { display:inline-flex; align-items:center; gap:7px; padding:9px 20px; border-radius:7px; border:none; cursor:pointer;
  font-size:13px; font-weight:600; }
.bn-btn:disabled { opacity:.45; cursor:not-allowed; }
.bn-btn-primary { background:var(--accent); color:#fff; }
.bn-btn-ghost { background:none; border:1px solid var(--border); color:var(--text2); }
.bn-alert { padding:11px 16px; border-radius:8px; font-size:13px; margin-bottom:16px; }
.bn-alert-error { background:rgba(248,113,113,.08); border:1px solid rgba(248,113,113,.25); color:var(--red); }
.bn-alert-warn { background:rgba(245,158,11,.08); border:1px solid rgba(245,158,11,.25); color:var(--amber); }
.bn-alert-info { background:rgba(2,132,199,.06); border:1px solid rgba(2,132,199,.2); color:var(--text2); }
.bn-progress { display:flex; align-items:center; gap:12px; font-size:14px; color:var(--text2); }
.bn-spinner { width:18px; height:18px; border:2px solid var(--b2); border-top-color:var(--accent); border-radius:50%;
  animation:bnspin .7s linear infinite; flex-shrink:0; }
@keyframes bnspin { to { transform:rotate(360deg); } }
.bn-table-wrap { overflow-x:auto; border:1px solid var(--border); border-radius:8px; }
.bn-table { width:100%; border-collapse:collapse; font-size:12px; }
.bn-table th { background:var(--s2); text-align:left; padding:8px 12px; border-bottom:1px solid var(--border); white-space:nowrap; color:var(--text); }
.bn-table td { padding:8px 12px; border-bottom:1px solid var(--b2); vertical-align:top; color:var(--text2); }
.bn-table tr:last-child td { border-bottom:none; }
.bn-na { color:var(--muted); font-style:italic; }
.bn-pill { display:inline-block; padding:2px 8px; border-radius:10px; font-size:11px; font-weight:600; }
.bn-pill-High { background:rgba(5,150,105,.12); color:var(--green); }
.bn-pill-Medium { background:rgba(245,158,11,.14); color:var(--amber); }
.bn-pill-Low { background:rgba(96,128,170,.14); color:var(--muted); }
.bn-pill-Pass { background:rgba(5,150,105,.12); color:var(--green); }
.bn-pill-Fail { background:rgba(220,38,38,.1); color:var(--red); }
.bn-pill-Unable { background:rgba(245,158,11,.14); color:var(--amber); }
.bn-rec { border:1px solid var(--border); border-radius:10px; padding:18px; margin-bottom:12px; }
.bn-rec-head { display:flex; align-items:center; gap:10px; flex-wrap:wrap; margin-bottom:10px; }
.bn-rank { width:28px; height:28px; border-radius:50%; background:var(--accent); color:#fff; display:flex;
  align-items:center; justify-content:center; font-weight:700; font-size:13px; flex-shrink:0; }
.bn-rec-name { font-size:15px; font-weight:700; color:var(--text); }
.bn-rec-toggle { cursor:pointer; user-select:none; margin-bottom:4px; }
.bn-rec-toggle:focus-visible { outline:2px solid var(--accent); outline-offset:4px; border-radius:6px; }
.bn-chevron { display:inline-block; width:14px; color:var(--muted); font-size:13px; transition:transform .15s; }
.bn-chevron.open { transform:rotate(90deg); }
.bn-rec-summary { font-size:12px; color:var(--muted); margin:0 0 6px 24px; }
.bn-rec-more { color:var(--accent); font-weight:600; }
.bn-rec-toolbar { display:flex; justify-content:space-between; align-items:center; gap:12px; margin-bottom:14px; flex-wrap:wrap; }
.bn-rec-tools { display:flex; align-items:center; gap:8px; font-size:12px; color:var(--muted); }
.bn-rec-tools button { background:none; border:none; padding:0; color:var(--accent); font-weight:600; font-size:12px; cursor:pointer; }
.bn-rec-tools button:hover { text-decoration:underline; }
.bn-rec p { font-size:13px; color:var(--text2); line-height:1.6; margin:6px 0; }
.bn-sub { font-size:11px; font-weight:700; letter-spacing:.06em; text-transform:uppercase; color:var(--muted); margin:12px 0 6px; }
.bn-list { margin-left:18px; font-size:13px; color:var(--text2); line-height:1.6; }
.bn-legend { display:flex; gap:16px; flex-wrap:wrap; font-size:12px; color:var(--text2); margin-bottom:10px; }
.bn-history-head { display:flex; justify-content:space-between; align-items:center; padding:0 4px 12px;
  border-bottom:1px solid var(--b2); font-size:11px; font-weight:700; letter-spacing:.07em; text-transform:uppercase; color:var(--muted); }
.bn-history-row { display:flex; align-items:center; gap:16px; padding:14px 12px; margin:0 -12px; border-radius:8px;
  border-bottom:1px solid var(--b2); font-size:13px; cursor:pointer; transition:background .15s; }
.bn-history-row:last-child { border-bottom:none; }
.bn-history-row:hover { background:var(--s2); }
.bn-history-title { font-size:14px; font-weight:600; color:var(--text); display:flex; align-items:center; gap:8px; }
.bn-history-meta { font-size:12px; color:var(--muted); margin-top:4px; display:flex; align-items:center; gap:8px; }
.bn-tag { display:inline-block; padding:2px 8px; border-radius:10px; font-size:11px; font-weight:600;
  background:rgba(15,118,110,.08); color:var(--accent); }
.bn-status { display:inline-flex; align-items:center; gap:5px; font-size:11px; font-weight:600; }
.bn-status::before { content:""; width:6px; height:6px; border-radius:50%; background:currentColor; }
.bn-status-completed { color:var(--green); }
.bn-status-running, .bn-status-queued, .bn-status-awaiting_confirmation { color:var(--amber); }
.bn-status-failed { color:var(--red); }
.bn-view-btn { padding:7px 14px; border-radius:7px; border:1px solid var(--accent); background:var(--surface);
  color:var(--accent); font-size:12px; font-weight:600; cursor:pointer; white-space:nowrap; transition:background .15s, color .15s; }
.bn-view-btn:hover { background:var(--accent); color:#fff; }
.bn-icon-btn { width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; border-radius:7px;
  border:1px solid transparent; background:none; color:var(--muted); cursor:pointer; transition:color .15s, background .15s, border-color .15s; }
.bn-icon-btn:hover { color:var(--red); background:rgba(220,38,38,.06); border-color:rgba(220,38,38,.2); }
a.bn-link { color:#1d4ed8; }
`;

const COUNTRY_CODES = (
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO " +
  "JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR " +
  "MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO " +
  "RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV " +
  "TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW"
).split(" ");

// "OM" -> "Oman", using the browser's own country names.
const countryName = (code) => {
  try { return new Intl.DisplayNames(["en"], { type: "region" }).of(code) || code; } catch { return code; }
};

const FILLS = { Green: "#DCF3DC", Blue: "#DDEBFF", Peach: "#FCE4D6" };
const DEFAULT_RULES = [
  ["Green", "Members in similar business as mine"],
  ["Blue", "Members as highly potential referrals"],
  ["Peach", "Members as potential referrals"],
];
const REGIONAL_URL_HELP = "Enter BNI Regional website link, if you have for precise and faster search or if you do not get results";

const EMPTY_FORM = {
  highlight_members: false, highlight_mode: "Default",
  custom_green_text: "", custom_blue_text: "", custom_peach_text: "",
  home_country: "", home_city: "", is_bni_member: null, bni_category: "", business_profile: "",
  user_intention: null, user_objective: "", priority_referral_partners: "", include_ai_suggestions: null,
  target_country: "", target_city: "", bni_regional_website_url: "",
  location_scope: null, postcode: "", locality: "", maximum_travel_minutes: "", travel_mode: null, radius_km: "",
};

const NA = <span className="bn-na">Not publicly available</span>;
const val = (v) => (v === null || v === undefined || v === "" ? NA : v);

function Field({ label, help, error, children }) {
  return (
    <div className="bn-field">
      <label className="bn-label">{label}</label>
      {children}
      {help && <span className="bn-help">{help}</span>}
      {error && <span className="bn-err">{error}</span>}
    </div>
  );
}

function Choices({ value, options, onChange }) {
  return (
    <div className="bn-choices">
      {options.map(([v, label, disabled]) => (
        <button type="button" key={String(v)} className={`bn-choice${value === v ? " on" : ""}`}
                disabled={!!disabled} onClick={() => onChange(v)}>
          {label}
        </button>
      ))}
    </div>
  );
}

function ExtLink({ href, children }) {
  if (!href) return NA;
  return <a className="bn-link" href={href} target="_blank" rel="noopener noreferrer">{children || href}</a>;
}

/* ── Form ────────────────────────────────────────────────── */
// "Tell us about you" answers pre-fill from the user's latest search
// (GET /bni/about-you), which bni_searches already stores.
const ABOUT_FIELDS = ["home_country", "home_city", "is_bni_member", "bni_category", "business_profile"];

// A saved search's answers back into form values (numbers as text, nulls
// as the empty defaults) for "Search a smaller area".
function formFromInput(input) {
  return Object.fromEntries(Object.keys(EMPTY_FORM).map((k) => {
    const v = input?.[k];
    if (v === null || v === undefined) return [k, EMPTY_FORM[k]];
    return [k, typeof v === "number" ? String(v) : v];
  }).concat([["highlight_mode", input?.highlight_mode || EMPTY_FORM.highlight_mode]]));
}

function SearchForm({ onStarted, nearMeAvailable, initial = null }) {
  const [f, setF] = useState(() => (initial ? formFromInput(initial) : EMPTY_FORM));
  const [remembered, setRemembered] = useState(false);
  const localityRef = useRef(null);
  // Opened to narrow a large search: bring the Near Me box into view.
  useEffect(() => {
    if (!initial) return;
    const t = setTimeout(() => {
      const box = localityRef.current;
      if (box) { box.scrollIntoView({ behavior: "smooth", block: "center" }); box.focus({ preventScroll: true }); }
    }, 300);
    return () => clearTimeout(t);
  }, [initial]);
  useEffect(() => {
    if (initial) return; // already filled from the search being narrowed
    let cancelled = false;
    api.get("/bni/about-you").then(({ data }) => {
      if (cancelled || !data || !ABOUT_FIELDS.some((k) => data[k] != null && data[k] !== "")) return;
      // Only fill fields the user hasn't started typing in yet.
      setF((p) => ({
        ...p,
        ...Object.fromEntries(ABOUT_FIELDS
          .filter((k) => p[k] === EMPTY_FORM[k] && data[k] != null)
          .map((k) => [k, data[k]])),
      }));
      setRemembered(true);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [initial]);
  const clearAbout = () => {
    setRemembered(false);
    setF((p) => ({ ...p, ...Object.fromEntries(ABOUT_FIELDS.map((k) => [k, EMPTY_FORM[k]])) }));
  };
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));
  const countryName = useMemo(() => {
    try { return new Intl.DisplayNames(["en"], { type: "region" }); } catch { return null; }
  }, []);
  const countries = useMemo(
    () => COUNTRY_CODES.map((c) => [c, countryName?.of(c) || c]).sort((a, b) => a[1].localeCompare(b[1])),
    [countryName]
  );
  const input = (k, props = {}) => (
    <input className={`bn-input${errors[k] ? " err" : ""}`} value={f[k]} onChange={set(k)} {...props} />
  );
  const area = (k, props = {}) => (
    <textarea className={`bn-input${errors[k] ? " err" : ""}`} value={f[k]} onChange={set(k)} {...props} />
  );
  const countrySelect = (k) => (
    <select className={`bn-input${errors[k] ? " err" : ""}`} value={f[k]} onChange={set(k)}>
      <option value="">Select a country…</option>
      {countries.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
    </select>
  );

  const nearMe = f.location_scope === "Near Me";
  const hasPostcode = f.postcode.trim() !== "";

  // After a failed submit, bring the first field with an error into view so
  // it isn't missed somewhere above the button.
  useEffect(() => {
    if (Object.keys(errors).length) {
      document.querySelector(".bn-err")?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [errors]);

  async function submit() {
    setBusy(true); setErrors({}); setSubmitError("");
    try {
      const { data } = await api.post("/bni/searches", f);
      onStarted(data.id);
    } catch (e) {
      const d = e.response?.data?.detail;
      if (d?.errors) {
        setErrors(d.errors);
        setSubmitError("Please correct the highlighted fields.");
      } else {
        setSubmitError(typeof d === "string" ? d : "Could not start the search. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      {initial && (
        <div className="bn-alert bn-alert-info">
          Filled in from your search for <b>{initial.target_city}</b>.{" "}
          {nearMeAvailable
            ? "Choose an area under Near Me below (a locality and radius, or a postcode), then search again."
            : "Near Me isn't available yet, so try a more specific target city instead."}
        </div>
      )}
      {/* Scene 1 — personalisation */}
      <div className="bn-card">
        <div className="bn-step">1. Personalise</div>
        <div className="bn-step-sub">Optional: colour members in the results and the Excel file.</div>
        <div className="bn-row">
          <Field label="Would you like to highlight members?">
            <Choices value={f.highlight_members} options={[[true, "Yes"], [false, "No"]]} onChange={set("highlight_members")} />
          </Field>
        </div>
        {f.highlight_members && (
          <>
            <div className="bn-row">
              <Field label="Highlighting options" error={errors.highlight_mode}>
                <Choices value={f.highlight_mode} options={[["Default", "Default"], ["Customize", "Customize"]]} onChange={set("highlight_mode")} />
              </Field>
            </div>
            {f.highlight_mode === "Default" ? (
              <div className="bn-legend">
                {DEFAULT_RULES.map(([c, d]) => <span key={c}><span className="bn-swatch" style={{ background: FILLS[c] }} />{c}: {d}</span>)}
              </div>
            ) : (
              <>
                {[["custom_green_text", "Green"], ["custom_blue_text", "Blue"], ["custom_peach_text", "Peach"]].map(([k, c]) => (
                  <div className="bn-row" key={k}>
                    <Field label={<><span className="bn-swatch" style={{ background: FILLS[c] }} />{c} — describe the members to highlight</>}
                           error={errors[k]}>
                      {input(k, { placeholder: c === "Green" ? "e.g. Members belonging to construction-related businesses" : "Optional" })}
                    </Field>
                  </div>
                ))}
                <div className="bn-help">Enter at least one. Blank colours are not used.</div>
              </>
            )}
          </>
        )}
      </div>

      {/* Scene 2 — about you */}
      <div className="bn-card">
        <div className="bn-step">2. Tell us about you</div>
        {remembered ? (
          <div className="bn-step-sub">
            Filled in from your last search. You can edit it, or{" "}
            <button type="button" className="bn-link" onClick={clearAbout}
                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer", font: "inherit" }}>
              clear it
            </button>.
          </div>
        ) : null}
        <div className="bn-row">
          <Field label="Your country" error={errors.home_country}>{countrySelect("home_country")}</Field>
          <Field label="Your city" help="Your home/business city — not where you want to search." error={errors.home_city}>{input("home_city")}</Field>
        </div>
        <div className="bn-row">
          <Field label="Are you an existing BNI member?" error={errors.is_bni_member}>
            <Choices value={f.is_bni_member} options={[[true, "Yes"], [false, "No"]]} onChange={set("is_bni_member")} />
          </Field>
          {f.is_bni_member === true && <Field label="Your BNI category" error={errors.bni_category}>{input("bni_category")}</Field>}
        </div>
        <div className="bn-row">
          <Field label="Briefly describe what you do" help="Your services/products and typical clients." error={errors.business_profile}>
            {area("business_profile")}
          </Field>
        </div>
      </div>

      {/* Scene 3 — mission */}
      <div className="bn-card">
        <div className="bn-step">3. What is your intention?</div>
        <div className="bn-row">
          <Field error={errors.user_intention}>
            <Choices value={f.user_intention} onChange={set("user_intention")}
                     options={[["Join", "I am looking to join a chapter"], ["Visit", "I am an existing BNI member looking to visit a relevant chapter"]]} />
          </Field>
        </div>
        {f.user_intention && (
          <div className="bn-row">
            <Field error={errors.user_objective}
                   label={f.user_intention === "Join" ? "What are you looking for from joining a chapter?"
                                                      : "What is the purpose of your visit, and what would you like to achieve?"}>
              {area("user_objective")}
            </Field>
          </div>
        )}
        <div className="bn-row">
          <Field label="What kind of referral partners would you prioritise?" error={errors.priority_referral_partners}>
            {area("priority_referral_partners", { placeholder: "e.g. Accountants, managed IT providers" })}
          </Field>
        </div>
        <div className="bn-row">
          <Field label="May we also identify other suitable referral partners beyond your stated priorities?" error={errors.include_ai_suggestions}>
            <Choices value={f.include_ai_suggestions} options={[[true, "Yes"], [false, "No"]]} onChange={set("include_ai_suggestions")} />
          </Field>
        </div>
      </div>

      {/* Scene 4 & 5 — destination and geography */}
      <div className="bn-card">
        <div className="bn-step">4. Where should we search?</div>
        <div className="bn-row">
          <Field label="Target country" error={errors.target_country}>{countrySelect("target_country")}</Field>
          <Field label="Target city" error={errors.target_city}>{input("target_city")}</Field>
        </div>
        <div className="bn-row">
          <Field label="BNI regional website link (optional)" help={REGIONAL_URL_HELP} error={errors.bni_regional_website_url}>
            {input("bni_regional_website_url", { placeholder: "https://…" })}
          </Field>
        </div>
        <div className="bn-row">
          <Field label="Location" error={errors.location_scope}
                 help={nearMeAvailable ? null : "Near Me needs a map service, which isn't set up yet. Search all chapters in the city instead."}>
            <Choices value={f.location_scope} onChange={set("location_scope")}
                     options={[["All", "All chapters in the city"], ["Near Me", "Near Me", !nearMeAvailable]]} />
          </Field>
        </div>
        {nearMe && (
          <>
            <div className="bn-row">
              <Field label="Postcode" error={errors.postcode}>{input("postcode")}</Field>
              <Field label="Precise locality / address" help="Enter a postcode or a locality." error={errors.locality}>{input("locality", { ref: localityRef })}</Field>
            </div>
            {hasPostcode ? (
              <div className="bn-row">
                <Field label="Maximum travel time (minutes)" error={errors.maximum_travel_minutes}>
                  {input("maximum_travel_minutes", { inputMode: "numeric" })}
                </Field>
                <Field label="Travel mode" error={errors.travel_mode}>
                  <Choices value={f.travel_mode} onChange={set("travel_mode")}
                           options={[["Driving", "Driving"], ["Public transport", "Public transport"], ["Walking", "Walking"]]} />
                </Field>
              </div>
            ) : (
              <div className="bn-row">
                <Field label="Search radius (km)" help="Straight-line distance in kilometres." error={errors.radius_km}>
                  {input("radius_km", { inputMode: "decimal" })}
                </Field>
              </div>
            )}
          </>
        )}
      </div>

      {submitError && <div className="bn-alert bn-alert-error">{submitError}</div>}
      <button className="bn-btn bn-btn-primary" disabled={busy} onClick={submit}>
        {busy ? "Starting…" : "Search chapters"}
      </button>
    </>
  );
}

/* ── Results ─────────────────────────────────────────────── */
const FIELD_LABELS = {
  name: "name", meeting_day: "meeting day", start_time_local: "meeting time", end_time_local: "end time",
  timezone: "time zone", format: "format", venue_name: "venue", venue_address: "address",
  chapter_url: "chapter link", member_directory_url: "member list", city: "city", active_status: "status",
};

/* Numbered links to the pages a chapter's facts came from; hovering shows
   which facts each page supports (spec section 6: sources next to claims). */
function SourceLinks({ sources }) {
  const list = (sources || []).filter((s) => s.url);
  if (!list.length) return <span className="bn-na">Not publicly available</span>;
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {list.map((s, i) => (
        <a key={i} className="bn-link" href={s.url} target="_blank" rel="noopener noreferrer" style={{ marginRight: 6 }}
           title={`Source for: ${(s.supports || []).map((f) => FIELD_LABELS[f] || f.replace(/_/g, " ")).join(", ") || "chapter details"}`}>
          [{i + 1}]
        </a>
      ))}
    </span>
  );
}

function meetingTime(ch) {
  const t = [ch.start_time_local, ch.end_time_local].filter(Boolean).join(" – ");
  if (!t) return NA;
  return <>{t}{ch.timezone ? ` (${ch.timezone})` : <span className="bn-na"> (time zone not verified)</span>}</>;
}

function proximityCell(p) {
  if (!p) return NA;
  const cls = p.status === "Pass" ? "Pass" : p.status === "Fail" ? "Fail" : "Unable";
  const measure = p.minutes != null ? `${Math.round(p.minutes)} min ${p.mode ? `(${p.mode})` : ""}`
                : p.km != null ? `${p.km.toFixed(2)} km straight-line` : null;
  return (
    <>
      <span className={`bn-pill bn-pill-${cls}`}>{p.status}</span>
      {measure && <div>{measure}</div>}
      {p.reason && <div className="bn-na">{p.reason}</div>}
    </>
  );
}

function Results({ search, running = false }) {
  // Recommendation cards fold to a one-line summary; the top-ranked one
  // starts open. Every chapter stays listed (no hidden cut-off).
  const [openRecs, setOpenRecs] = useState(null);
  const recIds = (search.report?.recommendations || []).map((r) => r.chapter_id);
  const isOpen = (id) => (openRecs ? openRecs.has(id) : id === recIds[0]);
  const toggleRec = (id) => setOpenRecs((prev) => {
    const next = new Set(prev || (recIds[0] ? [recIds[0]] : []));
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });
  const [downloading, setDownloading] = useState(false);
  const [exportError, setExportError] = useState("");
  const ui = search.user_input;
  const discovery = search.discovery || { chapters: [] };
  const report = search.report || {};
  const chapters = Object.fromEntries(discovery.chapters.map((c) => [c.chapter_id, c]));
  const prox = Object.fromEntries((search.proximity || []).map((p) => [p.chapter_id, p]));
  const rosters = Object.fromEntries((search.rosters || []).map((r) => [r.chapter_id, r]));
  const highlights = Object.fromEntries((report.member_highlights || []).map((h) => [`${h.chapter_id}|${h.member_id}`, h]));
  const nearMe = ui.location_scope === "Near Me";
  const passing = discovery.chapters.filter((c) => prox[c.chapter_id]?.status === "Pass");
  const rules = search.highlight_rules || [];
  const regional = discovery.regional_url;

  async function download() {
    setDownloading(true); setExportError("");
    try {
      const res = await api.get(`/bni/searches/${search.id}/export`, { responseType: "blob" });
      // Content-Disposition isn't readable cross-origin (CORS doesn't expose
      // it), so rebuild the same BNI_[Country]_[City]_YYYY-MM-DD name here.
      const clean = (s) => (s || "").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "X";
      const name = `BNI_${clean(ui.target_country)}_${clean(ui.target_city)}_${String(search.research_timestamp).slice(0, 10)}.xlsx`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
    } catch {
      setExportError("Could not generate the Excel file.");
    } finally {
      setDownloading(false);
    }
  }

  const memberName = (cid, mid) => rosters[cid]?.members.find((m) => m.member_id === mid);
  // A member's name with their highlight colour (same fill as the member
  // table and Excel), hover showing the reason; plain when highlighting is off.
  const nameTag = (cid, mid) => {
    const mem = memberName(cid, mid);
    const h = ui.highlight_members ? highlights[`${cid}|${mid}`] : null;
    if (!h?.colour) return <b>{mem?.name}</b>;
    return (
      <b title={h.reason || ""} style={{ background: FILLS[h.colour], padding: "1px 6px", borderRadius: 4 }}>{mem?.name}</b>
    );
  };

  return (
    <>
      <div className="bn-card">
        <div className="bn-card-title">Search</div>
        <p style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.7 }}>
          <b>Intention:</b> {ui.user_intention === "Join" ? "Join a chapter" : "Visit as an existing BNI member"}<br />
          <b>Objective:</b> {ui.user_objective}<br />
          <b>Destination:</b> {ui.target_city}, {countryName(ui.target_country)}
          {nearMe && <> · <b>Near Me:</b> {search.origin?.formatted_address}{" "}
            {ui.postcode ? `within ${ui.maximum_travel_minutes} min by ${ui.travel_mode}` : `within ${ui.radius_km} km (straight-line)`}</>}<br />
          <b>Business:</b> {ui.business_profile}<br />
          <b>Research date:</b> {new Date(search.research_timestamp).toLocaleString()}
        </p>
        {report.criteria_summary && <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 8 }}>{report.criteria_summary}</p>}
      </div>

      {report.results_status === "Partial" && (
        <div className="bn-alert bn-alert-warn">
          <b>Partial results</b> — {[
            discovery.discovery_coverage !== "Complete" && "chapter discovery could not be fully verified",
            (search.rosters || []).some((r) => r.coverage !== "Complete") && "some member lists were incomplete or unavailable",
            (search.proximity || []).some((p) => p.status === "Unable to verify") && "some chapter locations could not be verified",
          ].filter(Boolean).join("; ") || "some evidence was incomplete"}.
        </div>
      )}
      {(regional?.status && regional.status !== "Not provided") || report.regional_source_disclosure ? (
        <div className="bn-alert bn-alert-info">
          <b>Regional website:</b> {regional?.status}{regional?.failure_reason ? ` — ${regional.failure_reason}` : ""}
          {regional?.fallback_web_search_used ? " · normal web search was also used" : ""}
          {report.regional_source_disclosure && <div style={{ marginTop: 4 }}>{report.regional_source_disclosure}</div>}
        </div>
      ) : null}

      {/* A — all city chapters */}
      <div className="bn-card">
        <div className="bn-card-title">Chapters found in {ui.target_city} ({discovery.chapters.length})</div>
        {discovery.chapters.length === 0 ? <p className="bn-na">No chapters were found.</p> : (
          <div className="bn-table-wrap">
            <table className="bn-table">
              <thead><tr>
                <th>Chapter</th><th>Meeting day</th><th>Local time</th><th>Venue</th><th>Format</th><th>Link</th><th>Sources</th>
                <th>Data</th>{nearMe && <th>Proximity</th>}
              </tr></thead>
              <tbody>
                {discovery.chapters.map((c) => {
                  const r = rosters[c.chapter_id];
                  return (
                    <tr key={c.chapter_id}>
                      <td><b>{c.name}</b>{c.active_status === "Uncertain" && <div className="bn-na">Activity status uncertain</div>}</td>
                      <td>{val(c.meeting_day)}</td>
                      <td>{meetingTime(c)}</td>
                      <td>{c.format === "Online" ? "Online meeting" : val([c.venue_name, c.venue_address].filter(Boolean).join(", "))}</td>
                      <td>{c.format}</td>
                      <td><ExtLink href={c.chapter_url}>Chapter page</ExtLink></td>
                      <td><SourceLinks sources={c.sources} /></td>
                      <td>{r ? `Members: ${r.coverage}` : nearMe ? "Not researched (outside filter)" : "—"}</td>
                      {nearMe && <td>{proximityCell(prox[c.chapter_id])}</td>}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {(discovery.limitations || []).length > 0 && (
          <ul className="bn-list" style={{ marginTop: 10 }}>{discovery.limitations.map((l, i) => <li key={i}>{l}</li>)}</ul>
        )}
      </div>

      {/* B — Near Me subset */}
      {nearMe && (
        <div className="bn-card">
          <div className="bn-card-title">Chapters near you ({passing.length})</div>
          {passing.length === 0 ? <p className="bn-na">No chapters passed the filter. The search area was not widened.</p> : (
            <ul className="bn-list">
              {passing.map((c) => <li key={c.chapter_id}><b>{c.name}</b> — {proximityCell(prox[c.chapter_id])} <span className="bn-na">{prox[c.chapter_id]?.basis}</span></li>)}
            </ul>
          )}
        </div>
      )}

      {/* Recommendations placeholder while research runs (the server sends
          member counts only until the search finishes) */}
      {running && !search.report ? (
        <div className="bn-card">
          <div className="bn-card-title">Recommendations</div>
          {search.status === "awaiting_confirmation" ? (
            <p className="bn-na">Waiting for you to confirm the search above.</p>
          ) : (
            <div className="bn-progress"><div className="bn-spinner" />
              {search.stage === "analysis" ? "AI is matching members to your business and ranking chapters…" : "Reading member lists…"}
            </div>
          )}
          {(search.rosters || []).length > 0 && (
            <ul className="bn-list" style={{ marginTop: 10 }}>
              {(search.rosters || []).map((r) => (
                <li key={r.chapter_id}>
                  {chapters[r.chapter_id]?.name} — {r.retrieved_member_count ?? 0} members · coverage {r.coverage}
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
      <div className="bn-card">
        <div className="bn-rec-toolbar">
          <div className="bn-card-title" style={{ marginBottom: 0 }}>{report.report_title}</div>
          {recIds.length > 1 && (
            <div className="bn-rec-tools">
              <button type="button" onClick={() => setOpenRecs(new Set(recIds))}>Expand all</button>
              <span>·</span>
              <button type="button" onClick={() => setOpenRecs(new Set())}>Collapse all</button>
            </div>
          )}
        </div>
        {ui.highlight_members && rules.length > 0 && (
          <div className="bn-legend">
            {rules.map((r) => <span key={r.rule_id}><span className="bn-swatch" style={{ background: FILLS[r.colour] }} />{r.description}</span>)}
          </div>
        )}
        {(report.recommendations || []).length === 0 && <p className="bn-na">No chapters to recommend.</p>}
        {(report.recommendations || []).map((rec) => {
          const c = chapters[rec.chapter_id] || {};
          const roster = rosters[rec.chapter_id];
          return (
            <div className="bn-rec" key={rec.chapter_id}>
              <div className="bn-rec-head bn-rec-toggle" role="button" tabIndex={0} aria-expanded={isOpen(rec.chapter_id)}
                   onClick={() => toggleRec(rec.chapter_id)}
                   onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggleRec(rec.chapter_id); } }}>
                <span className={`bn-chevron${isOpen(rec.chapter_id) ? " open" : ""}`} aria-hidden="true">▸</span>
                {rec.rank != null ? <div className="bn-rank">{rec.rank}</div> : null}
                <div className="bn-rec-name">{c.name}</div>
                {rec.relevance ? <span className={`bn-pill bn-pill-${rec.relevance}`}>{rec.relevance}</span>
                               : <span className="bn-pill bn-pill-Unable">Insufficient evidence</span>}
                <span style={{ fontSize: 12, color: "var(--muted)" }}>
                  {c.meeting_day || ""} {c.start_time_local || ""}{c.timezone ? ` (${c.timezone})` : ""} · {c.format}{" "}
                  <span onClick={(e) => e.stopPropagation()}><SourceLinks sources={c.sources} /></span>
                </span>
              </div>
              <div className="bn-rec-summary">
                {rec.matches.length} matching member{rec.matches.length === 1 ? "" : "s"}
                {rec.own_category_overlap.length > 0 &&
                  ` · ${rec.own_category_overlap.length} possible overlap${rec.own_category_overlap.length === 1 ? "" : "s"}`}
                {roster ? ` · ${roster.members.length} member${roster.members.length === 1 ? "" : "s"} listed` : ""}
                {!isOpen(rec.chapter_id) && <span className="bn-rec-more"> · Show details</span>}
              </div>
              {isOpen(rec.chapter_id) && (<>
              {rec.potential_benefit && <p><b>Potential benefit:</b> {rec.potential_benefit}</p>}
              {rec.matches.length > 0 && (
                <>
                  <div className="bn-sub">Matching members</div>
                  <ul className="bn-list">
                    {rec.matches.map((m, i) => {
                      const mem = memberName(rec.chapter_id, m.member_id);
                      return (
                        <li key={i}>
                          {nameTag(rec.chapter_id, m.member_id)}{mem?.company ? `, ${mem.company}` : ""} — {mem?.category || m.partner_type}{" "}
                          <span className="bn-na">({m.match_type})</span>: {m.reason}{" "}
                          {m.source_urls.map((u, j) => <ExtLink key={j} href={u}>[source]</ExtLink>)}
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
              {rec.own_category_overlap.length > 0 && (
                <>
                  <div className="bn-sub">Possible overlap with your category</div>
                  <ul className="bn-list">
                    {rec.own_category_overlap.map((o, i) => <li key={i}>{nameTag(rec.chapter_id, o.member_id)}: {o.reason}</li>)}
                  </ul>
                  <p className="bn-na">
                    {ui.user_intention === "Join" ? "Category availability and admission must be confirmed with the chapter."
                                                  : "Please confirm the situation with the chapter."}
                  </p>
                </>
              )}
              {rec.limitations.length > 0 && (
                <>
                  <div className="bn-sub">Limitations</div>
                  <ul className="bn-list">{rec.limitations.map((l, i) => <li key={i}>{l}</li>)}</ul>
                </>
              )}
              {roster && (
                <details style={{ marginTop: 10 }}>
                  <summary style={{ cursor: "pointer", fontSize: 12, color: "var(--accent)", fontWeight: 600 }}>
                    All members ({roster.members.length}{roster.published_member_count != null ? ` of ${roster.published_member_count} published` : ""}) · coverage {roster.coverage}
                  </summary>
                  {roster.members.length === 0 ? <p className="bn-na">{roster.limitations.join(" ") || "Member list not available."}</p> : (
                    <div className="bn-table-wrap" style={{ marginTop: 8 }}>
                      <table className="bn-table">
                        <thead><tr><th>Member</th><th>Company</th><th>Category</th><th>Profile</th>{ui.highlight_members && <th>Highlight</th>}</tr></thead>
                        <tbody>
                          {roster.members.map((m) => {
                            const h = highlights[`${rec.chapter_id}|${m.member_id}`];
                            const bg = ui.highlight_members && h?.colour ? FILLS[h.colour] : undefined;
                            return (
                              <tr key={m.member_id} style={bg ? { background: bg } : undefined} title={h?.reason || ""}>
                                <td><b>{m.name}</b></td><td>{val(m.company)}</td><td>{val(m.category)}</td>
                                <td><ExtLink href={m.bni_profile_url}>Profile</ExtLink></td>
                                {ui.highlight_members && <td>{h?.reason || ""}</td>}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </details>
              )}
              </>)}
            </div>
          );
        })}
        {(report.overall_limitations || []).length > 0 && (
          <>
            <div className="bn-sub">Overall limitations</div>
            <ul className="bn-list">{report.overall_limitations.map((l, i) => <li key={i}>{l}</li>)}</ul>
          </>
        )}
      </div>
      )}

      {!running && (
        <>
          {exportError && <div className="bn-alert bn-alert-error">{exportError}</div>}
          <button className="bn-btn bn-btn-primary" onClick={download} disabled={downloading}>
            {downloading ? "Generating…" : "Generate Excel"}
          </button>
        </>
      )}
    </>
  );
}

function SearchView({ id, onBack, onRefine, backLabel = "← New search" }) {
  const [search, setSearch] = useState(null);
  const [error, setError] = useState("");
  const [reconnecting, setReconnecting] = useState(false);
  const [pollKey, setPollKey] = useState(0);
  const [continuing, setContinuing] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    let failures = 0;
    async function poll() {
      try {
        const { data } = await api.get(`/bni/searches/${id}`);
        if (cancelled) return;
        failures = 0;
        setReconnecting(false);
        setError("");
        setSearch(data);
        if (data.status === "queued" || data.status === "running") timer.current = setTimeout(poll, 3000);
      } catch (e) {
        if (cancelled) return;
        if (e.response?.status === 404) { setError("This search no longer exists."); return; }
        // A brief server hiccup (e.g. a 502 while it restarts) shouldn't end
        // the page: keep trying for a while before giving up.
        failures += 1;
        if (failures <= 20) {
          setReconnecting(true);
          timer.current = setTimeout(poll, Math.min(3000 * failures, 15000));
        } else {
          setReconnecting(false);
          setError("Could not reach the server. Please check again later from “My searches”.");
        }
      }
    }
    poll();
    return () => { cancelled = true; clearTimeout(timer.current); };
  }, [id, pollKey]);

  async function continueSearch() {
    setContinuing(true);
    try {
      await api.post(`/bni/searches/${id}/continue`);
      setPollKey((k) => k + 1);
    } catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not continue the search. Please try again.");
    } finally {
      setContinuing(false);
    }
  }

  const active = search && (search.status === "queued" || search.status === "running");
  return (
    <>
      <button className="bn-btn bn-btn-ghost" style={{ marginBottom: 16 }} onClick={onBack}>{backLabel}</button>
      {error && <div className="bn-alert bn-alert-error">{error}</div>}
      {reconnecting && <div className="bn-alert bn-alert-warn">Lost connection to the server — retrying…</div>}
      {!search && !error && <div className="bn-progress"><div className="bn-spinner" /> Loading…</div>}
      {active && (
        <div className="bn-card">
          <div className="bn-progress"><div className="bn-spinner" /> {search.progress || "Working…"}</div>
          <p className="bn-help" style={{ marginTop: 10 }}>Results appear below as soon as each step is ready. You can leave this page and come back from “My searches”.</p>
        </div>
      )}
      {search?.status === "awaiting_confirmation" && (
        <div className="bn-alert bn-alert-warn">
          <b>Large search.</b> {search.progress}
          {search.user_input?.location_scope !== "Near Me" && " You can use Near Me to search a smaller area instead."}
          <div className="bn-choices" style={{ marginTop: 12 }}>
            <button className="bn-btn bn-btn-primary" disabled={continuing} onClick={continueSearch}>
              {continuing ? "Starting…" : "Continue anyway"}
            </button>
            <button className="bn-btn bn-btn-ghost" onClick={() => (onRefine ? onRefine(search.user_input) : onBack())}>
              Search a smaller area
            </button>
          </div>
        </div>
      )}
      {(active || search?.status === "awaiting_confirmation") && search.discovery && (
        <Results search={search} running />
      )}
      {search?.status === "failed" && <div className="bn-alert bn-alert-error">{search.error || "The research failed."}</div>}
      {search?.status === "completed" && <Results search={search} />}
    </>
  );
}

function History({ onOpen }) {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/bni/searches").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  async function remove(id) {
    if (!window.confirm("Delete this search and its results? This can't be undone.")) return;
    await api.delete(`/bni/searches/${id}`);
    load();
  }
  if (!rows) return <div className="bn-progress"><div className="bn-spinner" /> Loading…</div>;
  if (rows.length === 0) return <p className="bn-na">No searches yet.</p>;
  const when = (d) => new Date(d).toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric",
                                                               hour: "numeric", minute: "2-digit" });
  const statusLabel = { completed: "Completed", running: "In progress", queued: "In progress",
                        awaiting_confirmation: "Waiting for your OK", failed: "Failed" };
  return (
    <div className="bn-card">
      <div className="bn-history-head"><span>Your searches</span><span>{rows.length}</span></div>
      {rows.map((r) => (
        <div className="bn-history-row" key={r.id} onClick={() => onOpen(r.id)}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="bn-history-title">
              {r.target_city}, {countryName(r.target_country)}
              <span className="bn-tag">{r.user_intention === "Visit" ? "Visit" : "Join"}</span>
            </div>
            <div className="bn-history-meta">
              <span>{when(r.created_at)}</span>
              <span className={`bn-status bn-status-${r.status}`}>{statusLabel[r.status] || r.status}</span>
            </div>
          </div>
          <button className="bn-view-btn" onClick={(e) => { e.stopPropagation(); onOpen(r.id); }}>View results →</button>
          <button className="bn-icon-btn" title="Delete search" aria-label="Delete search"
                  onClick={(e) => { e.stopPropagation(); remove(r.id); }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                 strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6" /><path d="M14 11v6" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}

export default function BniAdvisor() {
  const [tab, setTab] = useState("new");
  // A result opened from "My searches" stays under that tab; a search just
  // started from the form stays under "New search".
  const [openId, setOpenId] = useState(null);
  const [historyOpenId, setHistoryOpenId] = useState(null);
  const [nearMeAvailable, setNearMeAvailable] = useState(true);
  // "Search a smaller area": a new form pre-filled with that search's
  // answers, switched to Near Me (when available) to narrow the area.
  const [prefill, setPrefill] = useState(null);
  const [formKey, setFormKey] = useState(0);
  useEffect(() => {
    api.get("/bni/config").then(({ data }) => setNearMeAvailable(!!data.near_me_available)).catch(() => {});
  }, []);
  const refine = (input) => {
    setPrefill({ ...input, location_scope: nearMeAvailable ? "Near Me" : input.location_scope });
    setFormKey((k) => k + 1);
    setOpenId(null);
    setHistoryOpenId(null);
    setTab("new");
  };
  const startedFromForm = (id) => { setPrefill(null); setOpenId(id); };

  return (
    <>
      <style>{CSS}</style>
      <div className="bn-tabs">
        <button className={`bn-tab${tab === "new" ? " active" : ""}`} onClick={() => { setTab("new"); setOpenId(null); setPrefill(null); setFormKey((k) => k + 1); }}>New search</button>
        <button className={`bn-tab${tab === "history" ? " active" : ""}`} onClick={() => { setTab("history"); setHistoryOpenId(null); }}>My searches</button>
      </div>
      {tab === "history"
        ? (historyOpenId
            ? <SearchView id={historyOpenId} onBack={() => setHistoryOpenId(null)} onRefine={refine}
                          backLabel="← Back to my searches" />
            : <History onOpen={setHistoryOpenId} />)
        : openId ? <SearchView id={openId} onBack={() => setOpenId(null)} onRefine={refine} />
        : <SearchForm key={formKey} onStarted={startedFromForm} nearMeAvailable={nearMeAvailable} initial={prefill} />}
    </>
  );
}
